import { WithStyles, withStyles } from '@mui/styles';
import { HTML5toTouch } from 'rdndmb-html5-to-touch';
import React from 'react';
import { DndProvider } from 'react-dnd-multi-backend';
import Box from 'react-layout-components';

import styles from './Page.styles';

interface Props extends WithStyles<typeof styles> {
  children: React.ReactNode;
}

class Page extends React.Component<Props> {
  public render() {
    const { classes, children } = this.props;
    return (
      <DndProvider options={HTML5toTouch}>
        <Box column className={classes.page}>
          {children}
        </Box>
      </DndProvider>
    );
  }
}

export default withStyles(styles)(Page);
